import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gradient-to-br from-primary-50 to-secondary-50">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/">
          <img
            className="mx-auto h-20 w-auto"
            src="/assets/logo.webp"
            alt="Tchin-Lait"
          />
        </Link>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Tchin-Lait
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Système de gestion des demandes de produits
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="glassmorphism py-8 px-4 sm:px-10">
          <Outlet />
        </div>
        
        <div className="mt-4 text-center">
          <Link
            to="/request"
            className="font-medium text-primary-600 hover:text-primary-500"
          >
            Accéder au formulaire de demande public
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
